module.exports = __webpack_public_path__ + "img/03_full.d53e28ff.jpg";